class Routes {

	static async getRoutes(app) {
		let boot_webapp = app.boot_webapp;

		let routes = [];

		// my-bounty routes if not disabled
		if (!boot_webapp || !boot_webapp.routes || !boot_webapp.routes || !boot_webapp.routes.bounties || (boot_webapp.routes.bounties.disabled !== true)) {
			const MyBountyRoutes = await import('./mybounty-routes.js');

			const mybountyroutes = MyBountyRoutes.default.getRoutes(app);
	
			if (mybountyroutes) {
				for (var i = 0; i < mybountyroutes.length; i++) {
					routes.push(mybountyroutes[i]);
				}
			}
		}

		// my-deed routes if not disabled
		if (!boot_webapp || !boot_webapp.routes || !boot_webapp.routes || !boot_webapp.routes.deeds || (boot_webapp.routes.deeds.disabled !== true)) {
			const MyDeedRoutes = await import('./mydeed-routes.js');

			const mydeedroutes = MyDeedRoutes.default.getRoutes(app);
	
			if (mydeedroutes) {
				for (var i = 0; i < mydeedroutes.length; i++) {
					routes.push(mydeedroutes[i]);
				}
			}
		}

		// my-quotes routes if not disabled
		if (!boot_webapp || !boot_webapp.routes || !boot_webapp.routes || !boot_webapp.routes.quotes || (boot_webapp.routes.quotes.disabled !== true)) {
			const MyQuoteRoutes = await import('./myquote-routes.js');

			const myquoteroutes = MyQuoteRoutes.default.getRoutes(app);
	
			if (myquoteroutes) {
				for (var i = 0; i < myquoteroutes.length; i++) {
					routes.push(myquoteroutes[i]);
				}
			}
		}

		// my-open-wallet routes if not disabled
		if (!boot_webapp || !boot_webapp.routes || !boot_webapp.routes || !boot_webapp.routes.openwallet || (boot_webapp.routes.openwallet.disabled !== true)) {
			const MyOpenWalletRoutes = await import('./myopenwallet-routes.js');

			const myopenwalletroutes = MyOpenWalletRoutes.default.getRoutes(app);
	
			if (myopenwalletroutes) {
				for (var i = 0; i < myopenwalletroutes.length; i++) {
					routes.push(myopenwalletroutes[i]);
				}
			}
		}

		// xtra routes
		if (boot_webapp && boot_webapp.routes && boot_webapp.routes && boot_webapp.routes.xtra_routes) {
			try {
				const App = app.getAppClass();
				const AppStore = App.getAppStore();
				const route_modules = AppStore.route_modules;
				// note: paths have to be included by webpack before being used dynamically
				// so imports have to done on fixed strings (e.g. in index.js) prior to being used

				if (AppStore.route_modules) {
					const xtra_routes = Object.values(boot_webapp.routes.xtra_routes);
		
					for (var i = 0; i < xtra_routes.length; i++) {
						let route_def = xtra_routes[i];
		
						if (route_def.disabled === false) {
							let name = route_def.name;
							let TheRoutes = route_modules[name];

							if (!TheRoutes)
								continue;
		
							const theroutes = TheRoutes.default.getRoutes(app);
					
							if (theroutes) {
								for (var j = 0; j < theroutes.length; j++) {
									routes.push(theroutes[j]);
								}
							}
			
						}
					}
	
				}

			}
			catch(e) {
				console.log('exception in Routes.getRoutes for xtra routes: ' + e);
			}
		}

		return routes;
	}
}

export default Routes;